import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import StepProgress from '../../components/StepProgress'; // Custom breadcrumb/stepper UI
import Step1 from './steps/Step1_AccountInfo';
import Step2 from './steps/Step2_AddressInfo';
import Step3 from './steps/Step3_ContactInfo';
import Step4 from './steps/Step4_Requirements';
import Step5 from './steps/Step5_BillInfo';
import Step6 from './steps/Step6_Confirm';

import { submitCustomerApplication } from '../../api/customer';

const NewApplication = () => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({});
    const navigate = useNavigate();

  const next = () => setStep((prev) => Math.min(prev + 1, 6));
  const back = () => setStep((prev) => Math.max(prev - 1, 1));

      const handleSubmit = async () => {
          try {
                  await submitCustomerApplication(formData);
                  
                        Swal.fire({
                          icon: 'success',
                          title: 'Application Submitted!',
                          text: 'Customer profile has been saved successfully.',
                          confirmButtonText: 'OK'
                        }).then(() => {
                          navigate('/crm/customers'); // ✅ redirect after OK
                        });
          } catch (err) {
              console.error('Error submitting application:', err);
              alert('There was an error. Please try again.');
          }
      };

  const steps = {
    1: <Step1 formData={formData} setFormData={setFormData} />,
    2: <Step2 formData={formData} setFormData={setFormData} />,
    3: <Step3 formData={formData} setFormData={setFormData} />,
    4: <Step4 formData={formData} setFormData={setFormData} />,
    5: <Step5 formData={formData} setFormData={setFormData} />,
    6: <Step6 formData={formData} />
  };

  return (
    <div>
      <h3 className="mb-4">New Service Application</h3>
      <StepProgress currentStep={step} />

      {steps[step]}

      <div className="d-flex justify-content-between mt-4">
        <Button variant="secondary" onClick={back} disabled={step === 1}>
          Back
        </Button>
        {step < 6 ? (
          <Button variant="primary" onClick={next}>
            Next
          </Button>
        ) : (
          <Button variant="success" onClick={handleSubmit}>
                        Submit Application
                    </Button>
        )}
      </div>
    </div>
  );
};

export default NewApplication;
